export default __webpack_public_path__ + "static/babyCry-b16b0d1a67ed56bbf037b7181813eb77.jpg";